module.exports = __webpack_public_path__ + "images/cf7d3cc07c6a60fe3dcaee19f52087e2.svg";